/*
 * @Author: linguang linguang@nextmar.com
 * @Date: 2025-04-03 11:08:32
 * @LastEditors: Gao Deng gaodeng@nextmar.com
 * @LastEditTime: 2025-05-08 14:18:56
 * @FilePath: /zeelool-nextjs/src/store/defaultState.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { initialCartState } from './slices/cartSlice';
import { initialGlobalDialogState } from './slices/globalDialogSlice';
import { GlobalState, initialGlobalState } from './slices/globalSlice';
import { initialOrderState } from './slices/orderSlice';
import { initialPageCacheState, PageCacheState } from './slices/pageCacheSlice';
import { initialSurveyState, SurveyState } from './slices/surveySlice';
import { initialUserState, UserState } from './slices/userSlice';
import { initialWishState, WishState } from './slices/wishSlice';

export type StoreState = GlobalState & UserState & SurveyState & WishState & PageCacheState;
export const defaultState: StoreState = {
  ...initialGlobalState,
  ...initialUserState,
  ...initialSurveyState,
  ...initialCartState,
  ...initialOrderState,
  ...initialWishState,
  ...initialPageCacheState,
  ...initialGlobalDialogState,
};
